<template>
	<modal
		title="Cart expired"
		first-button-text="OK"
		:dark-theme="darkTheme"
		:first-button-action="closeModal"
		@close="closeModal"
	>
		<div>
			Carts left unattended for 1 hour are automatically abandoned.
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue'
import { mapMutations } from 'vuex'
import routerMixin from '@/mixins/routerMixin'

export default {
	name: 'ExpiredCartModal',

	mixins: [routerMixin],

	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	components: { Modal },

	methods: {
		...mapMutations('cart', ['toggleIsCartRecreated']),

		closeModal() {
			const routeName = this.$route.name

			if (routeName !== 'products' && routeName !== 'products-category') {
				this.goToProducts()
			}

			this.toggleIsCartRecreated()
		}
	}
}
</script>
